module.exports = {"title":"Verfügbare TLDs (Domain-Endungen)","header":{"registry":"Registry / Backend","id":"Payload ID","tlds":"TLDs (Domain-Endungen)"}}